import { api } from './api';

export interface Client {
  id: string;
  name: string;
  industry: string;
  contact_name: string;
  contact_email: string;
  status: 'active' | 'inactive' | 'in_progress';
  strategies_count: number;
  created_at: string;
  updated_at: string;
}

export interface ClientListResponse {
  data: Client[];
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

export interface CreateClientRequest {
  name: string;
  industry: string;
  contact_name: string;
  contact_email: string;
  status: 'active' | 'inactive' | 'in_progress';
}

export interface UpdateClientRequest {
  name?: string;
  industry?: string;
  contact_name?: string;
  contact_email?: string;
  status?: 'active' | 'inactive' | 'in_progress';
}

export const clientService = {
  list: async (page = 1, limit = 10, search = '', sort = '', order = ''): Promise<ClientListResponse> => {
    const response = await api.get('/clients', {
      params: { page, limit, search, sort, order },
    });
    return response.data;
  },

  getById: async (id: string): Promise<Client> => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  create: async (data: CreateClientRequest): Promise<Client> => {
    const response = await api.post('/clients', data);
    return response.data;
  },

  update: async (id: string, data: UpdateClientRequest): Promise<Client> => {
    const response = await api.patch(`/clients/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/clients/${id}`);
  },
};
